import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxLength: number, lang: string): string {
    if (value?.length <= maxLength) {
      return value;
    }

    if (lang === 'ar') {
      return '...' + value?.slice(0, maxLength);
    } else {
      return value?.slice(0, maxLength) + '...';
    }
  }
}
